import type { MetodoPagamento } from "interfaces/loja/pagamento";

export function labelMetodoPagamentoLoja(metodo: string): string {
  const map: Record<string, string> = {
    CARTAO_CREDITO: "Cartão de crédito",
    CARTAO_DEBITO: "Cartão de débito",
    PIX: "PIX",
    BOLETO: "Boleto",
  };
  return map[metodo] ?? metodo;
}

export function labelStatusPagamentoLoja(status: string): string {
  const map: Record<string, string> = {
    PENDENTE: "Pendente",
    AUTORIZADO: "Autorizado",
    PAGO: "Pago",
    ESTORNADO: "Estornado",
    FALHOU: "Falhou",
    CANCELADO: "Cancelado",
  };
  return map[status] ?? status;
}

/** Cor do Chip MUI conforme status */
export function chipColorStatusPagamento(
  status: string
): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" {
  switch (status) {
    case "PAGO":
      return "success";
    case "AUTORIZADO":
      return "info";
    case "PENDENTE":
      return "warning";
    case "ESTORNADO":
    case "CANCELADO":
    case "FALHOU":
      return "error";
    default:
      return "default";
  }
}

/** Texto de parcelas para cartão; null se não aplicável */
export function textoParcelasCartao(
  metodo: MetodoPagamento | string,
  parcelas?: number | null
): string | null {
  if (metodo !== "CARTAO_CREDITO" && metodo !== "CARTAO_DEBITO") return null;
  const n = typeof parcelas === "number" && parcelas >= 1 ? Math.min(24, parcelas) : 1;
  if (n === 1) return "À vista (1x)";
  return `Em ${n} parcelas`;
}

export function resumoIdPagamento(id: string): { curto: string; completo: string } {
  const completo = id.trim();
  if (completo.length <= 14) return { curto: completo, completo };
  return { curto: `${completo.slice(0, 10)}…`, completo };
}
